<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $tc("aggregator", 1) }} {{ $t("dailysalesreport") }}
      </div>
      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getAggregatorDailyReportFromDate"
                  @click.prevent="
                    onAggregatorDailyReportDateHandler({
                      event: null,
                      name: 'fromDate',
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  :value="getAggregatorDailyReportFromDate"
                  typeable
                  @selected="
                    onAggregatorDailyReportDateHandler({
                      event: $event,
                      name: 'fromDate',
                    })
                  "
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getAggregatorDailyReportFromDate ? 'active' : ''"
                  >{{ $t("transactions") }} {{ $t("date") }}</label
                >
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getDailyReportToDate"
                  v-on:click="onDailyReportDateHandler({event: null, name: 'toDate'})"
                >✖</button>
                <Datepicker :monday-first="true"
                  @selected="onDailyReportDateHandler({event: $event, name: 'toDate'})"
                  :value="getDailyReportToDate"
                  ref="programaticOpen"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getDailyReportToDate ? 'active': ''">End Date</label>
              </div>
            </div>
          </div>-->

          <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="getAggregatorDailyReportSelectedCinema && getDailyReportSelectedCinema.length > 0 ? 'shift-up' : ''"
              >{{ $t('select') }} {{ $tc('cinema', 1) }}</label>
              <b-dropdown
                :text="getDailyReportSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getCinemasList"
                  :key="dropdownIndex"
                  @click="onDailyReportDropdownHandler({ event: $event, name:'Cinema',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>-->
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  getDailyReportSelectedAggregatorUser &&
                  getDailyReportSelectedAggregatorUser.length > 0
                    ? 'shift-up'
                    : 'd-none'
                "
                >{{ $tc("user", 1) }}</label
              >
              <!-- <b-dropdown
                :text="getDailyReportSelectedAggregatorUser"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getAggregatorUserList"
                  :key="dropdownIndex"
                  @click="onAggregatorDailyReportDropdownHandler({ event: $event, name:'AggregatorUser',selectedItem: dropdownItem, index:dropdownIndex })"
                >
                  <span>{{ dropdownItem.user_id ? `${dropdownItem.first_name} ${dropdownItem.middle_name } ${ dropdownItem.last_name }`: 'All' }}</span>
                </b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :options="getAggregatorUserList"
                :searchable="true"
                :placeholder="
                  getDailyReportSelectedAggregatorUser &&
                  getDailyReportSelectedAggregatorUser.length > 0
                    ? getDailyReportSelectedAggregatorUser
                    : 'User'
                "
                :customLabel="setLabel"
                track-by="user_id"
                @select="
                  onAggregatorDailyReportDropdownHandler({
                    event: $event,
                    name: 'AggregatorUser',
                    selectedItem: $event,
                  })
                "
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  getAggregatorDailyReportSelectedPaymentMode &&
                  getAggregatorDailyReportSelectedPaymentMode.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("paymentmode") }}</label
              >
              <b-dropdown
                :text="getAggregatorDailyReportSelectedPaymentMode"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in getPaymentTypesList"
                  :key="dropdownIndex"
                  @click="
                    onAggregatorDailyReportDropdownHandler({
                      event: $event,
                      name: 'PaymentMode',
                      selectedItem: dropdownItem,
                      index: dropdownIndex,
                    })
                  "
                  >{{ dropdownItem.pm_payment_mode }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <!-- <div class="col-md-2">
          <div class="dropdown-curve-container mr-2">
            <label :class="getDailyReportSelectedOfferVoucher.length > 0 ? 'shift-up' : ''">Select Cinema</label>
            <b-dropdown :text="getDailyReportSelectedOfferVoucher" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(dropdownItem,dropdownIndex) in getOfferVoucherTypesList"
                :key="dropdownIndex"
                @click="onDailyReportDropdownHandler({ event: $event, name:'OfferVoucher',selectedItem: dropdownItem, index:dropdownIndex })"
              >{{ dropdownItem.offer_voucher_type }}</b-dropdown-item>
            </b-dropdown>
          </div>
          </div>-->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click="onFetchReport()">
              {{ $t("fetch") }} {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="
              getAggregatorDailyReportList.length > 0 ||
              getAggregatorDailyConcessionReportList.length > 0
            "
            class="col-lg-6 col-xl-2 align-self-center mb-3 d-flex justify-content-end"
          >
            <div class="mr-1">{{ $t("download") }} as:</div>
            <a
              v-if="getAggregatorDailyPDFFileName"
              :href="BASE_URL + getAggregatorDailyPDFFileName"
              target="_blank"
              download
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              v-if="getAggregatorDailyExcelFileName"
              :href="BASE_URL + getAggregatorDailyExcelFileName"
              target="_blank"
              title="Download as Excel"
              download
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </a>
          </div>

          <div class="col-md-3 align-self-center">
            <!-- <b-dropdown id="listview" variant="outline-blue-lg">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{selectedvalue}}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
            >{{list.name}}</b-dropdown-item>
            </b-dropdown>-->
          </div>
        </div>
      </div>

      <div class="swc-report">
        <!-- <div class="ml-3">PDF AND EXCEL</div> -->

        <table class="mb-2 swc-report-table" border="1" style="table-layout: auto">
          <thead>
            <tr class="bg-lightgrey" style="text-align: center">
              <th class="bg-lightgrey">{{ $tc("outlet") }}</th>
              <th class="bg-lightgrey">{{ $tc("user", 2) }}</th>
              <th class="bg-lightgrey">{{ $tc("suboutlet") }}</th>
              <th class="bg-lightgrey">
                {{ $tc("payment", 1) }} {{ $tc("type", 1) }} /
                {{ $t("partner") }}
              </th>
              <th class="bg-lightgrey">
                {{ $tc("offer", 1) }} / {{ $tc("voucher") }}
              </th>
              <th class="bg-lightgrey">
                {{ $t("number") }} Of {{ $tc("ticket", 1) }}
              </th>
              <th class="bg-lightgrey">{{ $t("net") }} {{ $t("revenue") }}</th>
              <th class="bg-lightgrey">
                {{ $t("gross") }} {{ $tc("revenue", 1) }}
              </th>
              <th class="bg-lightgrey">{{ $tc("internetHandling") }}</th>
              <th class="bg-lightgrey">{{ $tc("totalamount") }}</th>
              <th class="bg-lightgrey">{{ $tc("discount") }}</th>
              <th class="bg-lightgrey">{{ $t("balance") }}</th>
            </tr>
          </thead>
          <tbody
            v-if="
              getAggregatorDailyReportList.length === 0 &&
              getAggregatorDailyConcessionReportList.length === 0
            "
          >
            <tr rowspan="10">
              <td colspan="12">
                <!-- {{ $tc("NoRecords") }} -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
          <tbody
            v-for="(
              dailyReportItem, dailyReportItemIndex
            ) in getAggregatorDailyReportList"
            :key="dailyReportItemIndex"
          >
            <tr>
              <td rowspan="50">
                <strong>{{ $t("online") }}</strong>
              </td>
            </tr>

            <tr>
              <td rowspan="50">
                <strong>{{
                  dailyReportItem.Data[0].booking_user_name ||
                  dailyReportItem.Data[0].aggregator_name
                }}</strong>
              </td>
              <!--td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td-->
            </tr>
            <tr>
              <td>
                <strong>{{ $t("online") }}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <!-- <tr>
              <td></td>
              <td>Credit Card</td>
              <td>ADCB 20% Discount OFF ON TICKET</td>
              <td>11</td>
              <td>430.50</td>
              <td>86.10</td>
              <td>344.40</td>
            </tr>-->
            <!-- <tr
              v-for="(paymentMode,paymentModeIndex) in dailyReportItem.payments"
              :key="paymentModeIndex"
            >
              <td></td>
              <td>{{ paymentMode.pm_payment_mode }}</td>
              <td></td>
              <td>{{ paymentMode.total_seats }}</td>
              <td>{{ paymentMode.net_revenue.toFixed(this.MIN_FRACTION_DIGITS) }}</td>
              <td>0.00</td>
              <td>{{ paymentMode.gross_revenue.toFixed(this.MIN_FRACTION_DIGITS) }}</td>
            </tr>-->
            <!-- <tr>
              <td></td>
              <td>{{ dailyReportItem.payment_mode }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td>0.00</td>
              <td></td>
            </tr>-->
            <tr
              v-for="(paymentMode, paymentModeIndex) in dailyReportItem.Data"
              :key="paymentModeIndex + paymentMode.tickets"
            >
              <td></td>
              <td>{{ paymentMode.payment_mode }}</td>
              <td>
                {{
                  paymentMode.offer_name != "" || null
                    ? paymentMode.offer_name
                    : paymentMode.voucher_name != "" || null
                    ? paymentMode.voucher_name
                    : ""
                }}
              </td>
              <td class="text-right pr-1">{{ paymentMode.tickets }}</td>
              <td class="text-right pr-1">
                {{ currFormat(paymentMode.net_revenue) }}
              </td>
              <td class="text-right pr-1">
                {{ currFormat(paymentMode.total_amount) }}
              </td>
              <td class="text-right pr-1">
                {{ currFormat(paymentMode.internet_handling_fee) }}
              </td>
              <td class="text-right pr-1">
                {{
                  currFormat(
                    paymentMode.total_amount + paymentMode.internet_handling_fee
                  )
                }}
              </td>
              <td class="text-right pr-1">
                {{ currFormat(paymentMode.discount) }}
              </td>
              <td class="text-right pr-1">
                {{ currFormat(paymentMode.gross_revenue) }}
              </td>
            </tr>

            <tr>
              <td>
                <strong>{{ $t("online") }}</strong>
              </td>
              <td></td>

              <td>
                <!-- <strong>{{ dailyReportItem.payments.reduce(function(accumulator, { total_seats }) { return accumulator + parseFloat(total_seats); },0) }}</strong> -->
              </td>
              <td class="text-right pr-1">
                <!-- <strong>2.00</strong> -->
                <strong>{{
                  dailyReportItem.Data.reduce(function (
                    accumulator,
                    { tickets }
                  ) {
                    return accumulator + parseFloat(tickets);
                  },
                  0).toFixed(MIN_FRACTION_DIGITS)
                }}</strong>
              </td>
              <td class="text-right pr-1">
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { net_revenue }
                    ) {
                      return accumulator + parseFloat(net_revenue);
                    },
                    0)
                  )
                }}</strong>
                <!-- <strong>0.00</strong> -->
              </td>
              <td class="text-right pr-1">
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { total_amount }
                    ) {
                      return accumulator + parseFloat(total_amount);
                    },
                    0)
                  )
                }}</strong>
                <!-- <strong>0.00</strong> -->
              </td>
              <td class="text-right pr-1">
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { internet_handling_fee }
                    ) {
                      return accumulator + parseFloat(internet_handling_fee);
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td class="text-right pr-1">
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { total_amount, internet_handling_fee }
                    ) {
                      return (
                        accumulator +
                        parseFloat(total_amount + internet_handling_fee)
                      );
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td class="text-right pr-1">
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { discount }
                    ) {
                      return accumulator + parseFloat(discount);
                    },
                    0)
                  )
                }}</strong>
                <!-- <strong>3.00</strong> -->
              </td>
              <td class="text-right pr-1">
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { gross_revenue }
                    ) {
                      return accumulator + parseFloat(gross_revenue);
                    },
                    0)
                  )
                }}</strong>
              </td>
            </tr>
            <tr v-if="dailyReportItem.DataRefund">
              <td>
                <strong>{{ $t("Refund") }}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-else></tr>

            <tr
              v-for="(
                paymentMode1, paymentMode1Index
              ) in dailyReportItem.DataRefund"
              :key="paymentMode1Index + paymentMode1.payment_mode"
            >
              <td></td>
              <td>{{ paymentMode1.payment_mode }}</td>
              <td>
                {{
                  paymentMode1.offer_name != "" || null
                    ? paymentMode1.offer_name
                    : paymentMode1.voucher_name != "" || null
                    ? paymentMode1.voucher_name
                    : ""
                }}
              </td>
              <td>{{ paymentMode1.tickets }}</td>
              <td>{{ currFormat(paymentMode1.net_revenue) }}</td>
              <td>{{ currFormat(paymentMode1.total_amount) }}</td>
              <td>{{ currFormat(paymentMode1.discount) }}</td>
              <td>{{ currFormat(paymentMode1.gross_revenue) }}</td>
            </tr>

            <tr v-if="dailyReportItem.DataRefund">
              <td>
                <strong>{{ $t("Refund") }}</strong>
              </td>
              <td>{{}}</td>
              <td>{{}}</td>
              <td>
                <strong>{{
                  dailyReportItem.DataRefund.reduce(function (
                    accumulator,
                    { tickets }
                  ) {
                    return accumulator + parseFloat(tickets);
                  },
                  0).toFixed(MIN_FRACTION_DIGITS)
                }}</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { net_revenue }
                    ) {
                      return accumulator + parseFloat(net_revenue);
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { total_amount }
                    ) {
                      return accumulator + parseFloat(total_amount);
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { discount }
                    ) {
                      return accumulator + parseFloat(discount);
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { gross_revenue }
                    ) {
                      return accumulator + parseFloat(gross_revenue);
                    },
                    0)
                  )
                }}</strong>
              </td>
            </tr>
            <tr v-else></tr>

            <tr>
              <td>
                <strong>{{ $t("online") }}</strong>
              </td>
              <td></td>
              <td></td>

              <td class="text-right pr-1">
                <strong>{{
                  dailyReportItem.DataRefund
                    ? (
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { tickets }
                        ) {
                          return accumulator + parseFloat(tickets);
                        },
                        0) -
                        dailyReportItem.DataRefund.reduce(function (
                          accumulator,
                          { tickets }
                        ) {
                          return accumulator + parseFloat(tickets);
                        },
                        0)
                      ).toFixed(MIN_FRACTION_DIGITS)
                    : dailyReportItem.Data.reduce(function (
                        accumulator,
                        { tickets }
                      ) {
                        return accumulator + parseFloat(tickets);
                      },
                      0).toFixed(MIN_FRACTION_DIGITS)
                }}</strong>
              </td>
              <td class="text-right pr-1">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund
                      ? (
                          dailyReportItem.Data.reduce(function (
                            accumulator,
                            { net_revenue }
                          ) {
                            return accumulator + parseFloat(net_revenue);
                          },
                          0) -
                          dailyReportItem.DataRefund.reduce(function (
                            accumulator,
                            { net_revenue }
                          ) {
                            return accumulator + parseFloat(net_revenue);
                          },
                          0)
                        ).toFixed(this.MIN_FRACTION_DIGITS)
                      : dailyReportItem.Data.reduce(function (
                          accumulator,
                          { net_revenue }
                        ) {
                          return accumulator + parseFloat(net_revenue);
                        },
                        0)
                  )
                }}</strong>
              </td>
              <td class="text-right pr-1">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund
                      ? (
                          dailyReportItem.Data.reduce(function (
                            accumulator,
                            { total_amount }
                          ) {
                            return accumulator + parseFloat(total_amount);
                          },
                          0) -
                          dailyReportItem.DataRefund.reduce(function (
                            accumulator,
                            { total_amount }
                          ) {
                            return accumulator + parseFloat(total_amount);
                          },
                          0)
                        ).toFixed(MIN_FRACTION_DIGITS)
                      : dailyReportItem.Data.reduce(function (
                          accumulator,
                          { total_amount }
                        ) {
                          return accumulator + parseFloat(total_amount);
                        },
                        0)
                  )
                }}</strong>
              </td>
              <td class="text-right pr-1">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund
                      ? (
                          dailyReportItem.Data.reduce(function (
                            accumulator,
                            { internet_handling_fee }
                          ) {
                            return (
                              accumulator + parseFloat(internet_handling_fee)
                            );
                          },
                          0) -
                          dailyReportItem.DataRefund.reduce(function (
                            accumulator,
                            { internet_handling_fee }
                          ) {
                            return (
                              accumulator + parseFloat(internet_handling_fee)
                            );
                          },
                          0)
                        ).toFixed(MIN_FRACTION_DIGITS)
                      : dailyReportItem.Data.reduce(function (
                          accumulator,
                          { internet_handling_fee }
                        ) {
                          return (
                            accumulator + parseFloat(internet_handling_fee)
                          );
                        },
                        0)
                  )
                }}</strong>
              </td>
              <td class="text-right pr-1">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund
                      ? (
                          dailyReportItem.Data.reduce(function (
                            accumulator,
                            { total_amount, internet_handling_fee }
                          ) {
                            return (
                              accumulator +
                              parseFloat(total_amount + internet_handling_fee)
                            );
                          },
                          0) -
                          dailyReportItem.DataRefund.reduce(function (
                            accumulator,
                            { total_amount, internet_handling_fee }
                          ) {
                            return (
                              accumulator +
                              parseFloat(total_amount + internet_handling_fee)
                            );
                          },
                          0)
                        ).toFixed(MIN_FRACTION_DIGITS)
                      : dailyReportItem.Data.reduce(function (
                          accumulator,
                          { total_amount, internet_handling_fee }
                        ) {
                          return (
                            accumulator +
                            parseFloat(total_amount + internet_handling_fee)
                          );
                        },
                        0)
                  )
                }}</strong>
              </td>
              <td class="text-right pr-1">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund
                      ? (
                          dailyReportItem.Data.reduce(function (
                            accumulator,
                            { discount }
                          ) {
                            return accumulator + parseFloat(discount);
                          },
                          0) -
                          dailyReportItem.DataRefund.reduce(function (
                            accumulator,
                            { discount }
                          ) {
                            return accumulator + parseFloat(discount);
                          },
                          0)
                        ).toFixed(MIN_FRACTION_DIGITS)
                      : dailyReportItem.Data.reduce(function (
                          accumulator,
                          { discount }
                        ) {
                          return accumulator + parseFloat(discount);
                        },
                        0)
                  )
                }}</strong>
              </td>
              <td class="text-right pr-1">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund
                      ? (
                          dailyReportItem.Data.reduce(function (
                            accumulator,
                            { gross_revenue }
                          ) {
                            return accumulator + parseFloat(gross_revenue);
                          },
                          0) -
                          dailyReportItem.DataRefund.reduce(function (
                            accumulator,
                            { gross_revenue }
                          ) {
                            return accumulator + parseFloat(gross_revenue);
                          },
                          0)
                        ).toFixed(MIN_FRACTION_DIGITS)
                      : dailyReportItem.Data.reduce(function (
                          accumulator,
                          { gross_revenue }
                        ) {
                          return accumulator + parseFloat(gross_revenue);
                        },
                        0)
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>

          <!-- //for refund data -->
          <!-- <tbody v-if="getDailyRefundList.length == 0"></tbody>
          <tbody
            v-for="(dailyRefundItem, dailyRefundItemIndex) in getDailyRefundList"
            :key="dailyRefundItemIndex "
          >
            <tr>
              <td></td>
              <td></td>
              <td>
                <strong>{{ $t('Refund') }}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

            <tr
              v-for="(paymentMode,paymentModeIndex) in dailyRefundItem.Data"
              :key="paymentModeIndex "
            >
              <td></td>
              <td></td>
              <td></td>
              <td>{{ paymentMode.payment_mode}}</td>
              <td>{{ paymentMode.offer_name != '' || null ? paymentMode.offer_name : paymentMode.voucher_name != '' || null ? paymentMode.voucher_name:''}}</td>
              <td>{{ paymentMode.tickets}}</td>
              <td>{{paymentMode.net_revenue}}</td>
              <td>{{paymentMode.discount}}</td>
              <td>{{paymentMode.gross_revenue}}</td>
            </tr>
          </tbody>-->

          <!-- <tbody v-if="getDailyReportList.length > 0">
            <tr>
              <td colspan="5">
                <strong>{{ $t('boxoffice') }}</strong>
              </td>

              <td>
                <strong>{{ getBoxOfficeTotal.totalNumberOfTickets }}</strong>
              </td>
              <td>
                <strong>{{ getBoxOfficeTotal.totalNetRevenue.toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
              </td>
              <td>
                <strong>0.00</strong>
              </td>
              <td>
                <strong>{{ getBoxOfficeTotal.totalGrossRevenue.toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
              </td>
            </tr>
          </tbody>-->

          <!-- <tbody
            v-for="(DailyConcessionReportItem, DailyConcessionReportItemIndex) in getAggregatorDailyConcessionReportList"
            :key="DailyConcessionReportItemIndex"
          >
            <tr>
              <td rowspan="9">
                <strong>{{ $t('concession') }}</strong>
              </td>
            </tr>
            <tr>
              <td rowspan="9">
                <strong>{{ DailyConcessionReportItem.first_name }}&nbsp;{{ DailyConcessionReportItem.last_name }}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                <strong>{{ $t('concession') }}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

            <tr
              v-for="(TransactionItem, TransactionIndex) in DailyConcessionReportItem.transactions"
              :key="TransactionIndex"
            >
              <td></td>
              <td>{{ TransactionItem.pm_payment_mode }}</td>
              <td></td>
              <td>{{ TransactionItem.number_of_tickets }}</td>
              <td>{{ TransactionItem.net_revenue.toFixed(this.MIN_FRACTION_DIGITS) }}</td>
              <td>0.00</td>
              <td>{{ TransactionItem.gross_revenue.toFixed(this.MIN_FRACTION_DIGITS) }}</td>
            </tr>

            <tr>
              <td>
                <strong></strong>
              </td>
              <td>
                <strong>{{ $t('concession') }}</strong>
              </td>
              <td>
                <strong></strong>
              </td>
              <td>
                <strong>{{ DailyConcessionReportItem.transactions.reduce(function(accumulator, { number_of_tickets }) { return accumulator + parseFloat(number_of_tickets); },0) }}</strong>
              </td>
              <td>
                <strong>{{ DailyConcessionReportItem.transactions.reduce(function(accumulator, { net_revenue }) { return accumulator + parseFloat(net_revenue); },0).toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
              </td>
              <td>0.00</td>

              <td>
                <strong>{{ DailyConcessionReportItem.transactions.reduce(function(accumulator, { gross_revenue }) { return accumulator + parseFloat(gross_revenue); },0).toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
              </td>
            </tr>
          </tbody>-->

          <!-- <tbody v-if="getAggregatorDailyConcessionReportList.length > 0">
            <tr>
              <td colspan="5">
                <strong>{{ $t('concession') }}</strong>
              </td>
              <td>
                <strong>{{ getAggregatorConcessionOfficeTotal.totalNumberOfTickets }}</strong>
              </td>
              <td>
                <strong>{{ getAggregatorConcessionOfficeTotal.totalNetRevenue.toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
              </td>
              <td>0.00</td>
              <td>
                <strong>{{ getAggregatorConcessionOfficeTotal.totalGrossRevenue.toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
              </td>
            </tr>
          </tbody>-->

          <!-- <tbody
            v-if="getAggregatorDailyConcessionReportList.length > 0 || getAggregatorDailyReportList.length > 0"
          >
            <tr>
              <td class="bg-lightgrey">
                <strong>{{ $t('grand') }} {{ $t('total') }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>

              <td class="bg-lightgrey">
                <strong>{{ getAggregatorGrandTotal.totalNumberOfTickets }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong>{{ getAggregatorGrandTotal.totalNetRevenue.toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong>{{ getAggregatorGrandTotal.totalDiscount.toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
              </td>
              <td class="bg-lightgrey">
                <strong>{{ getAggregatorGrandTotal.totalGrossRevenue.toFixed(this.MIN_FRACTION_DIGITS) }}</strong>
              </td>
            </tr>
          </tbody>-->
        </table>
      </div>

      <div
        v-if="getAggregatorPaymentSummary.length > 0"
        class="swc-report mt-3"
      >
        <table class="swc-report-table" border="1" style="table-layout: auto">
          <thead>
            <tr>
              <th style="text-align: center" colspan="5">
                {{ $tc("payment", 1) }} {{ $t("type") }} {{ $t("wise") }}
                {{ $t("summary") }}
              </th>
            </tr>
            <tr class="bg-lightgrey" style="text-align: center">
              <th style="vertical-align: top" rowspan="2">
                {{ $t("outlet") }}
              </th>
              <th>
                {{ $tc("payment", 1) }} {{ $tc("type", 1) }} /
                {{ $t("partner") }}
              </th>
              <th>{{ $t("current") }}</th>
              <th>{{ $t("advance") }} {{ $t("sold") }} {{ $t("today") }}</th>
              <th style="vertical-align: top" rowspan="2">Total</th>
            </tr>
            <tr class="bg-lightgrey" style="text-align: center">
              <th>{{ $t("partners") }}</th>
              <th>
                <table class="w-100">
                  <thead>
                    <tr>
                      <th>{{ $tc("ticket", 1) }}</th>
                      <th>{{ $t("total") }} {{ $t("net") }}</th>
                      <th>{{ $t("total") }} {{ $t("gross") }}</th>
                    </tr>
                  </thead>
                </table>
              </th>
              <th>
                <table class="w-100">
                  <thead>
                    <tr>
                      <th>{{ $tc("ticket", 1) }}</th>
                      <th>{{ $t("total") }} {{ $t("net") }}</th>
                      <th>{{ $t("total") }} {{ $t("gross") }}</th>
                    </tr>
                  </thead>
                </table>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(Payment, PaymentIndex) in getAggregatorPaymentSummary"
              :key="PaymentIndex"
            >
              <td>{{ Payment.bs_source }}</td>
              <td>{{ Payment.pm_payment_mode }}</td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>{{ Payment.tickets }}</td>
                    <td>{{ currFormat(Payment.net_amount) }}</td>
                    <td>{{ currFormat(Payment.gross_amount) }}</td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>{{ Payment.advanceTickets }}</td>
                    <td>{{ currFormat(Payment.advanceNetAmount) }}</td>
                    <td>{{ currFormat(Payment.advanceGrossAmount) }}</td>
                  </tr>
                </table>
              </td>
              <td>
                {{
                  currFormat(Payment.gross_amount + Payment.advanceGrossAmount)
                }}
              </td>
            </tr>
            <tr class="bg-lightgrey">
              <td colspan="2">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>
                      {{
                        getAggregatorPaymentSummary.reduce(function (
                          accumulator,
                          { tickets }
                        ) {
                          return accumulator + parseFloat(tickets);
                        },
                        0)
                      }}
                    </td>
                    <td>
                      {{
                        currFormat(
                          getAggregatorPaymentSummary.reduce(function (
                            accumulator,
                            { net_amount }
                          ) {
                            return accumulator + parseFloat(net_amount);
                          },
                          0)
                        )
                      }}
                    </td>
                    <td>
                      {{
                        currFormat(
                          getAggregatorPaymentSummary.reduce(function (
                            accumulator,
                            { gross_amount }
                          ) {
                            return accumulator + parseFloat(gross_amount);
                          },
                          0)
                        )
                      }}
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>
                      {{
                        getAggregatorPaymentSummary.reduce(function (
                          accumulator,
                          { advanceTickets }
                        ) {
                          return accumulator + parseFloat(advanceTickets);
                        },
                        0)
                      }}
                    </td>
                    <td>
                      {{
                        currFormat(
                          getAggregatorPaymentSummary.reduce(function (
                            accumulator,
                            { advanceNetAmount }
                          ) {
                            return accumulator + parseFloat(advanceNetAmount);
                          },
                          0)
                        )
                      }}
                    </td>
                    <td>
                      {{
                        currFormat(
                          getAggregatorPaymentSummary.reduce(function (
                            accumulator,
                            { advanceGrossAmount }
                          ) {
                            return accumulator + parseFloat(advanceGrossAmount);
                          },
                          0)
                        )
                      }}
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                {{
                  currFormat(
                    getAggregatorPaymentSummary.reduce(function (
                      accumulator,
                      { advanceGrossAmount, gross_amount }
                    ) {
                      return (
                        accumulator +
                        parseFloat(gross_amount) +
                        parseFloat(advanceGrossAmount)
                      );
                    },
                    0)
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="getAggregatorFilmSummary.length > 0" class="swc-report mt-3">
        <table class="swc-report-table" border="1" style="table-layout: auto">
          <thead>
            <tr>
              <th style="text-align: center" colspan="5">Film Wise Summary</th>
            </tr>
            <tr class="bg-lightgrey" style="text-align: center">
              <th style="vertical-align: top" rowspan="2">
                {{ $t("outlet") }}
              </th>
              <th>{{ $t("current") }}</th>
              <th>{{ $t("advance") }} {{ $t("sold") }} {{ $t("today") }}</th>
              <th style="vertical-align: top" rowspan="2">Total</th>
            </tr>
            <tr class="bg-lightgrey" style="text-align: center">
              <th>
                <table class="w-100">
                  <thead>
                    <tr>
                      <th>{{ $tc("ticket", 1) }}</th>
                      <th>{{ $t("total") }} {{ $t("net") }}</th>
                      <th>{{ $t("total") }} {{ $t("gross") }}</th>
                    </tr>
                  </thead>
                </table>
              </th>
              <th>
                <table class="w-100">
                  <thead>
                    <tr>
                      <th>{{ $tc("ticket", 1) }}</th>
                      <th>{{ $t("total") }} {{ $t("net") }}</th>
                      <th>{{ $t("total") }} {{ $t("gross") }}</th>
                    </tr>
                  </thead>
                </table>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(filmItem, filmIndex) in getAggregatorFilmSummary"
              :key="filmIndex"
            >
              <td>
                <strong>{{ filmItem.movie }}</strong>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>{{ filmItem.ticket }}</td>
                    <td>{{ currFormat(filmItem.net_amount) }}</td>
                    <td>{{ currFormat(filmItem.gross_amount) }}</td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>{{ filmItem.advanceTickets }}</td>
                    <td>{{ currFormat(filmItem.advanceNetAmount) }}</td>
                    <td>{{ currFormat(filmItem.advanceGrossAmount) }}</td>
                  </tr>
                </table>
              </td>
              <td>
                {{
                  currFormat(
                    filmItem.gross_amount + filmItem.advanceGrossAmount
                  )
                }}
              </td>
            </tr>

            <tr class="bg-lightgrey">
              <td>
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>
                      <strong>{{
                        getAggregatorFilmSummary
                          .reduce(function (accumulator, { ticket }) {
                            return accumulator + parseFloat(ticket);
                          }, 0)
                          .toFixed(MIN_FRACTION_DIGITS)
                      }}</strong>
                    </td>
                    <td>
                      <strong>{{
                        currFormat(
                          getAggregatorFilmSummary.reduce(function (
                            accumulator,
                            { net_amount }
                          ) {
                            return accumulator + parseFloat(net_amount);
                          },
                          0)
                        )
                      }}</strong>
                    </td>
                    <td>
                      <strong>{{
                        currFormat(
                          getAggregatorFilmSummary.reduce(function (
                            accumulator,
                            { gross_amount }
                          ) {
                            return accumulator + parseFloat(gross_amount);
                          },
                          0)
                        )
                      }}</strong>
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>
                      <strong>{{
                        getAggregatorFilmSummary.reduce(function (
                          accumulator,
                          { advanceTickets }
                        ) {
                          return accumulator + parseFloat(advanceTickets);
                        },
                        0)
                      }}</strong>
                    </td>
                    <td>
                      <strong>{{
                        currFormat(
                          getAggregatorFilmSummary.reduce(function (
                            accumulator,
                            { advanceNetAmount }
                          ) {
                            return accumulator + parseFloat(advanceNetAmount);
                          },
                          0)
                        )
                      }}</strong>
                    </td>
                    <td>
                      <strong>{{
                        currFormat(
                          getAggregatorFilmSummary.reduce(function (
                            accumulator,
                            { advanceGrossAmount }
                          ) {
                            return accumulator + parseFloat(advanceGrossAmount);
                          },
                          0)
                        )
                      }}</strong>
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    getAggregatorFilmSummary.reduce(function (
                      accumulator,
                      { advanceGrossAmount, gross_amount }
                    ) {
                      return (
                        accumulator +
                        parseFloat(advanceGrossAmount) +
                        parseFloat(gross_amount)
                      );
                    },
                    0)
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        v-if="getAggregatorUserWiseSummary.length > 0"
        class="swc-report mt-3"
      >
        <table border="1" class="swc-report-table" style="table-layout: auto">
          <thead>
            <tr>
              <th style="text-align: center" colspan="6">User Wise Summary</th>
            </tr>
            <tr class="bg-lightgrey" style="text-align: center">
              <th>{{ $t("outlet") }}</th>
              <th>{{ $tc("user", 1) }} {{ $t("name") }}</th>
              <th>{{ $t("current") }}</th>
              <th>{{ $t("advance") }} {{ $t("sold") }} {{ $t("today") }}</th>
              <th>{{ $t("refund") }}</th>
              <th>{{ $t("total") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(UserItem, UserIndex) in getAggregatorUserWiseSummary"
              :key="UserIndex"
            >
              <td>{{ UserItem.bs_source }}</td>
              <td>{{ UserItem.booking_user_name }}</td>
              <td>{{ currFormat(UserItem.gross_amount) }}</td>
              <td>{{ currFormat(UserItem.advanceGrossAmount) }}</td>
              <td>0.00</td>
              <td>
                {{
                  currFormat(
                    UserItem.advanceGrossAmount + UserItem.gross_amount
                  )
                }}
              </td>
            </tr>
            <!-- <tr>
              <td>Box Office</td>
              <td>Liya</td>
              <td>5,623</td>
              <td>0.00</td>
              <td>0.00</td>
              <td>5,623.00</td>
            </tr>-->

            <tr class="bg-lightgrey">
              <td colspan="2">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    getAggregatorUserWiseSummary.reduce(function (
                      accumulator,
                      { gross_amount }
                    ) {
                      return accumulator + parseFloat(gross_amount);
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    getAggregatorUserWiseSummary.reduce(function (
                      accumulator,
                      { advanceGrossAmount }
                    ) {
                      return accumulator + parseFloat(advanceGrossAmount);
                    },
                    0)
                  )
                }}</strong>
              </td>
              <td>
                <strong>00.00</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    getAggregatorUserWiseSummary.reduce(function (
                      accumulator,
                      { gross_amount, advanceGrossAmount }
                    ) {
                      return (
                        accumulator +
                        (parseFloat(advanceGrossAmount) +
                          parseFloat(gross_amount))
                      );
                    },
                    0)
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="getAggregatorRefundSummary.length > 0" class="swc-report mt-3">
        <table border="1" class="swc-report-table" style="table-layout: auto">
          <thead>
            <tr>
              <th style="text-align: center" colspan="5">
                {{ $t("refund") }} {{ $t("summary") }}
              </th>
            </tr>
            <tr class="bg-lightgrey" style="text-align: center">
              <th>{{ $t("outlet") }}</th>
              <th>{{ $tc("user", 1) }}</th>
              <th>{{ $tc("payment", 1) }} {{ $tc("type", 1) }}</th>
              <th>{{ $tc("ticket", 1) }}</th>
              <th>{{ $t("refund") }} {{ $t("value") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(RefundItem, RefundIndex) in getAggregatorRefundSummary"
              :key="RefundIndex"
            >
              <td>{{ RefundItem.bs_source }}</td>
              <td>{{ RefundItem.username }}</td>
              <td>{{ RefundItem.pm_payment_mode }}</td>
              <td>{{ RefundItem.tickets }}</td>
              <td>{{ RefundItem.refund }}</td>
            </tr>
            <!-- <tr>
              <td>Box Office</td>
              <td>Charity</td>
              <td>Cash</td>
              <td>3</td>
              <td>110.25</td>
            </tr>-->
            <tr class="bg-lightgrey">
              <td>
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <strong></strong>
              </td>
              <td>
                <strong></strong>
              </td>
              <td>
                <strong>{{
                  getAggregatorRefundSummary.reduce(function (
                    accumulator,
                    { tickets }
                  ) {
                    return accumulator + parseFloat(tickets);
                  },
                  0)
                }}</strong>
              </td>
              <td>
                <strong>{{
                  currFormat(
                    getAggregatorRefundSummary.reduce(function (
                      accumulator,
                      { refund }
                    ) {
                      return accumulator + parseFloat(refund);
                    },
                    0)
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="false" class="swc-report mt-3">
        <table border="1" class="swc-report-table" style="table-layout: auto">
          <thead>
            <tr>
              <th style="text-align: center" colspan="4">
                {{ $t("advance") }} {{ $t("sold") }} {{ $t("today") }}'s
                (20-Sep-2019) {{ $t("show") }}
              </th>
            </tr>
            <tr class="bg-lightgrey" style="text-align: center">
              <th>{{ $t("outlet") }}</th>
              <th>{{ $tc("payment", 1) }} {{ $tc("type", 1) }}</th>
              <th>{{ $tc("ticket", 1) }}</th>
              <th>{{ $t("rrevenue") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ $t("boxoffice") }}</td>
              <td>{{ $t("cash") }}</td>
              <td>6</td>
              <td>189.00</td>
            </tr>

            <tr class="bg-lightgrey">
              <td colspan="2">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <strong>21</strong>
              </td>
              <td>
                <strong>787.77</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="false" class="swc-report mt-3">
        <table class="swc-report-table" border="1" style="table-layout: auto">
          <thead>
            <tr>
              <th style="text-align: center" colspan="6">
                {{ $t("advance") }} {{ $t("sold") }} {{ $t("today") }}
                {{ $t("summary") }}
              </th>
            </tr>
            <tr class="bg-lightgrey" style="text-align: center">
              <th style="vertical-align: top" rowspan="2">{{ $t("date") }}</th>
              <th>{{ $t("cash") }}</th>
              <th>{{ $t("creditcard") }}</th>
              <th>Comp</th>
              <th>{{ $t("prepaid") }}</th>
              <th style="vertical-align: top" rowspan="2">
                {{ $t("refund") }}
              </th>
            </tr>
            <tr class="bg-lightgrey" style="text-align: center">
              <th>
                <table class="w-100">
                  <thead>
                    <tr>
                      <th>BO</th>
                      <th>F&B</th>
                    </tr>
                  </thead>
                </table>
              </th>
              <th>
                <table class="w-100">
                  <thead>
                    <tr>
                      <th>BO</th>
                      <th>F&B</th>
                    </tr>
                  </thead>
                </table>
              </th>
              <th>
                <table class="w-100">
                  <thead>
                    <tr>
                      <th>BO</th>
                      <th>F&B</th>
                    </tr>
                  </thead>
                </table>
              </th>
              <th>
                <table class="w-100">
                  <thead>
                    <tr>
                      <th>BO</th>
                      <th>F&B</th>
                    </tr>
                  </thead>
                </table>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong>20/09/2019</strong>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>0.00</td>
                    <td>0.00</td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>0.00</td>
                    <td>0.00</td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>0.00</td>
                    <td>0.00</td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>0.00</td>
                    <td>0.00</td>
                  </tr>
                </table>
              </td>
              <td>0.00</td>
            </tr>
            <tr>
              <td>
                <strong>20/09/2019</strong>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>0.00</td>
                    <td>0.00</td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>0.00</td>
                    <td>0.00</td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>0.00</td>
                    <td>0.00</td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>0.00</td>
                    <td>0.00</td>
                  </tr>
                </table>
              </td>
              <td>0.00</td>
            </tr>

            <tr class="bg-lightgrey">
              <td>
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>
                      <strong>0.00</strong>
                    </td>
                    <td>
                      <strong>0.00</strong>
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>
                      <strong>0.00</strong>
                    </td>
                    <td>
                      <strong>0.00</strong>
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>
                      <strong>0.00</strong>
                    </td>
                    <td>
                      <strong>0.00</strong>
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="w-100">
                  <tr>
                    <td>
                      <strong>0.00</strong>
                    </td>
                    <td>
                      <strong>0.00</strong>
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <strong>0.00</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- DAILY CONCESSION REPORT -->
    <div class="white-wrapper">
      <h5>{{ $tc("dailyConcessionReport") }}</h5>
      <div class="swc-report">
        <table class="swc-report swc-report-table">
          <thead class="bg-lightgrey">
            <tr>
              <th>{{ $tc("outlet") }}</th>
              <th>{{ $tc("username") }}</th>
              <th>{{ $tc("username") }}</th>
              <th>{{ $tc("payment", 1) }} {{ $tc("type", 1) }}</th>
              <th>{{ $tc("offer") }}</th>
              <th>{{ $tc("quantity") }}</th>
              <th>{{ $tc("revenue") }}</th>
              <th>{{ $tc("discount") }}</th>
              <th>{{ $tc("balance") }}</th>
            </tr>
          </thead>
          <tbody v-if="getAggregatorDailyConcessionReportList.length === 0">
            <tr rowspan="9">
              <td colspan="9">
                <!-- {{ $tc('NoRecords') }} -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
          <tbody v-else class="sph-report">
            <tr
              v-for="(
                ConcessionItem, ConcessionIndex
              ) in getAggregatorDailyConcessionReportList"
              :key="ConcessionIndex"
            >
              <td>
                {{
                  ConcessionItem.FnbItems[0].paymentTypes[0].fst_booking_source
                }}
              </td>
              <td>{{ ConcessionItem.FnbItems[0].paymentTypes[0].username }}</td>
              <td class="w-80">
                <table
                  v-for="(FnbItem, FnbItemIndex) in ConcessionItem.FnbItems"
                  :key="FnbItemIndex"
                >
                  <tr
                    v-for="(PaymentItem, PaymentIndex) in FnbItem.paymentTypes"
                    :key="PaymentIndex"
                  >
                    <td style="width: 20px">
                      {{ PaymentIndex == 0 ? PaymentItem.fst_item_name : "" }}
                    </td>
                    <td style="width: 20px">
                      {{ PaymentItem.fst_payment_mode }}
                    </td>
                    <td style="width: 20px">{{ PaymentItem.ft_offer_name }}</td>
                    <td style="width: 20px">
                      {{ PaymentItem["SUM(ft.ft_quantity)"] }}
                    </td>
                    <td style="width: 20px">
                      {{ currFormat(PaymentItem["SUM(ft.ft_total_amount)"]) }}
                    </td>
                    <td style="width: 20px">
                      {{ currFormat(PaymentItem["ft_offer_price"]) }}
                    </td>
                    <td style="width: 20px">
                      {{ currFormat(PaymentItem["balance_amount"]) }}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { BASEURL } from "@/config/index";
import ReportsServiceV2 from "@/services/ReportsService-v2";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      BASEURL,
      DailyReportDataV2: [],
    };
  },
  computed: {
    ...mapGetters([
      // GET LIST ONLY
      "getPosUsersList",
      "getAggregatorUserList",
      "getPaymentTypesList",
      "getCinemasList",
      "getAggregatorDailyConcessionReportList",
      // Flags
      "getAggregatorDailyReportsIsCinema",
      "getAggregatorDailyReportsIsExcelDownload",
      // Rendered List
      "getAggregatorDailyReportList",
      "getAggregatorDailyRefundList",
      // Selected Dates
      "getAggregatorDailyReportToDate",
      "getAggregatorDailyReportFromDate",
      // Selected Dropdowns
      "getAggregatorDailyReportSelectedPaymentMode",
      "getAggregatorDailyReportSelectedPosUser",
      "getDailyReportSelectedAggregatorUser",
      "getAggregatorDailyReportSelectedCinema",
      // FILEs
      "getAggregatorDailyExcelFileName",
      // PSD
      "getAggregatorDailyPDFFileName",
      // GET TOTALs
      "getAggregatorGrandTotal",
      "getAggregatorBoxOfficeTotal",
      "getAggregatorConcessionOfficeTotal",
      "getAggregatorPaymentSummary",
      "getAggregatorFilmSummary",
      "getAggregatorUserWiseSummary",
      "getAggregatorRefundSummary",
      // "getConcessionDailyReportData"
    ]),
  },
  beforeMount() {
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    // this.onAggregatorDailyReportFlagHandler({
    //   event: null,
    //   name: "isCinema",
    //   value: cinemaId
    // });
    // this.fetchCinemasList({ cinemaId });
    this.fetchAggregatorsUsersList();
    // this.fetchPosUsersList();
    this.fetchPaymentTypesList();
  },
  mounted() {},
  methods: {
    setLabel(event) {
      if (event.first_name && event.first_name.length > 0) {
        return `${event.first_name ? event.first_name : ""} ${
          event.middle_name ? event.middle_name : ""
        } ${event.last_name ? event.last_name : ""}`;
      } else {
        return "All";
      }
    },
    onFetchReport() {
      this.fetchAggregatorDailyReportListv2();
      // this.onAggregatorDailyConcessionReport();
    },
    //     getDailyReportV2() {
    // ReportsServiceV2.GetDailyReportList().then((result)=>{

    // })
    //     },
    ...mapActions([
      // FETCH FROM MASTER STORE
      "fetchCinemasList",
      "fetchPosUsersList",
      "fetchAggregatorsUsersList",
      "fetchPaymentTypesList",

      // FETCH LIST ONLY
      "fetchAggregatorDailyReportListv2",
      "onAggregatorDailyReportDateHandler",
      "onAggregatorDailyReportDropdownHandler",
      "onAggregatorDailyReportFlagHandler",
      // "onAggregatorDailyConcessionReport",
      // ON RESET ALL
      "onResetAggregatorDailyReportStoreState",
    ]),
  },
  beforeDestroy: async function () {
    console.log("getDailyExcelFileName :", this.getDailyExcelFileName);
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getDailyExcelFileName,
    });
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getDailyPDFFileName,
    });
    // await this.onResetDailyReportStoreState();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/aggregatorsDailySalesReport.vue